import InfoMessage from './info-message';
import WarningMessage from './warning-message';
import OkMessage from './ok-message';

export { InfoMessage, WarningMessage, OkMessage };
export default InfoMessage;
